import addClickHandler from './events/addClickHandler';
import addStartupScript from './events/addStartupScript';
import forEachSelector from './elements/forEachSelector';
import 'element-closest-polyfill';

function openFirstDetail() {
  forEachSelector('.js-open-first-question', faq => {
    if(faq) {
      const detail = faq.querySelector('details');
      if(detail) detail.open = true;
    }
  });
}

function expandAllDetails() {
  forEachSelector('.faq__expand-button', expandAllButton => {
    addClickHandler(expandAllButton, function (e) {
      const faqContainer = e.target.closest('.faq');
      if (faqContainer) {
        e.target.classList.toggle('js-expand');
        const details = faqContainer.querySelectorAll('details');

        if (details) {
          details.forEach(detail => {
            detail.open = e.target.classList.contains('js-expand');
          });
        }
      }
    });
  });
}

export function setup() {
  openFirstDetail();
  expandAllDetails();
}

addStartupScript(setup);
